import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-center items-center h-screen" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_5 = { class: "flex w-full items-center justify-between" }
const _hoisted_6 = { class: "w-full px-3 sm:w-1/2 xl:w-1/4 sm:mt-0" }
const _hoisted_7 = { class: "flex items-center px-5 py-6 bg-white rounded-md shadow-sm" }
const _hoisted_8 = { class: "mx-5" }
const _hoisted_9 = { class: "text-2xl font-semibold text-gray-700" }
const _hoisted_10 = { class: "w-full px-3 sm:w-1/2 xl:w-1/4 sm:mt-0" }
const _hoisted_11 = { class: "flex items-center px-5 py-6 bg-white rounded-md shadow-sm" }
const _hoisted_12 = { class: "mx-5" }
const _hoisted_13 = { class: "text-2xl font-semibold text-gray-700" }
const _hoisted_14 = { class: "w-full px-3 mt-6 sm:w-1/2 xl:w-1/4 sm:mt-0" }
const _hoisted_15 = { class: "flex items-center px-5 py-6 bg-white rounded-md shadow-sm" }
const _hoisted_16 = { class: "mx-5" }
const _hoisted_17 = { class: "text-2xl font-semibold text-gray-700" }
const _hoisted_18 = { class: "w-full px-3 mt-6 sm:w-1/2 xl:w-1/4 sm:mt-0" }
const _hoisted_19 = { class: "flex items-center px-5 py-6 bg-white rounded-md shadow-sm" }
const _hoisted_20 = { class: "mx-5" }
const _hoisted_21 = { class: "text-2xl font-semibold text-gray-700" }
const _hoisted_22 = { class: "w-full px-3 mt-6 sm:w-1/2 xl:w-1/4 sm:mt-0" }
const _hoisted_23 = { class: "flex items-center px-5 py-6 bg-white rounded-md shadow-sm" }
const _hoisted_24 = { class: "mx-5" }
const _hoisted_25 = { class: "text-2xl font-semibold text-gray-700" }
const _hoisted_26 = { class: "w-full px-3 mt-6 sm:w-1/2 xl:w-1/4 sm:mt-0" }
const _hoisted_27 = { class: "flex items-center px-5 py-6 bg-white rounded-md shadow-sm" }
const _hoisted_28 = { class: "mx-5" }
const _hoisted_29 = { class: "text-2xl font-semibold text-gray-700" }

import { ref, watch, onMounted, computed } from "vue";
import axios from "axios";
import Banner from "../partials/AppBanner.vue";
import Breadcrumb from "../partials/AppBreadcrumb.vue";
import loader from "../assets/loader.svg";

interface Status {
  name: string;
}

interface BlogOrGuide {
  status: Status;
  [key: string]: any;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppDashboard',
  setup(__props) {

const baseUrl = process.env.VUE_APP_BASE_URL;
const blogs = ref<BlogOrGuide[]>([]);
const travelGuides = ref<BlogOrGuide[]>([]);
const loading = ref(true);
const tableHeadings = ["title", "category", "type", "status", "created at", "published at", "views", "action"];

const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString();
};

const fetchBlogs = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${baseUrl}/blog/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    blogs.value = response.data.data;
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const fetchTravelGuides = async () => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${baseUrl}/tour-guide/get`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    travelGuides.value = response.data.data;
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const initialProcess = async () => {
  await fetchBlogs();
  await fetchTravelGuides();
};

onMounted(() => {
  initialProcess();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Breadcrumb, { breadcrumb: "" }),
    _createVNode(Banner, { class: "hidden" }),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: _unref(loader),
              alt: "Loading...",
              class: "w-8 h-8"
            }, null, 8, _hoisted_3)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"p-3 bg-indigo-600 bg-opacity-75 rounded-full\"><svg class=\"w-8 h-8 text-white\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"></path><polyline points=\"14 2 14 8 20 8\"></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\"></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\"></line><polyline points=\"10 9 9 9 9 6\"></polyline></svg></div>", 1)),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("h4", _hoisted_9, _toDisplayString(blogs.value.length), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-gray-500" }, "Blogs", -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"p-3 bg-indigo-600 bg-opacity-75 rounded-full\"><svg class=\"w-8 h-8 text-white\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z\"></path><polyline points=\"14 2 14 8 20 8\"></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\"></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\"></line><polyline points=\"10 9 9 9 9 6\"></polyline></svg></div>", 1)),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("h4", _hoisted_13, _toDisplayString(travelGuides.value.length), 1),
                  _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-gray-500 whitespace-nowrap" }, "Travel Guides", -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"p-3 bg-pink-600 bg-opacity-75 rounded-full\"><svg class=\"w-8 h-8 text-white\" viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><circle cx=\"14\" cy=\"14\" r=\"12\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\"></circle><line x1=\"14\" y1=\"14\" x2=\"14\" y2=\"8\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"></line><line x1=\"14\" y1=\"14\" x2=\"18\" y2=\"14\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\"></line></svg></div>", 1)),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("h4", _hoisted_17, _toDisplayString(blogs.value.filter((blog) => blog.status.name === "pending").length + travelGuides.value.filter((guide) => guide.status.name === "pending").length), 1),
                  _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-gray-500" }, "Pending", -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[7] || (_cache[7] = _createElementVNode("div", { class: "p-3 bg-blue-600 bg-opacity-75 rounded-full" }, [
                  _createElementVNode("svg", {
                    class: "w-8 h-8 text-white",
                    viewBox: "0 0 28 28",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("circle", {
                      cx: "14",
                      cy: "14",
                      r: "13",
                      stroke: "currentColor",
                      "stroke-width": "2"
                    }),
                    _createElementVNode("path", {
                      d: "M8 15l5 5 9-10",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("h4", _hoisted_21, _toDisplayString(blogs.value.filter((blog) => blog.status.name === "approved").length + travelGuides.value.filter((guide) => guide.status.name === "approved").length), 1),
                  _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-gray-500" }, "Approved", -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"p-3 bg-blue-600 bg-opacity-75 rounded-full\"><svg class=\"w-8 h-8 text-white\" viewBox=\"0 0 28 28\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 4H16L20 8V24H4V4Z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\"></path><polyline points=\"16 4 16 8 20 8\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></polyline><path d=\"M8 15L12 19L18 11\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div>", 1)),
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("h4", _hoisted_25, _toDisplayString(blogs.value.filter((blog) => blog.status.name === "published").length + travelGuides.value.filter((guide) => guide.status.name === "published").length), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-gray-500" }, "Published", -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "p-3 bg-red-600 bg-opacity-75 rounded-full text-center" }, [
                  _createElementVNode("svg", {
                    class: "w-8 h-8 text-white",
                    viewBox: "0 0 28 28",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }, [
                    _createElementVNode("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      d: "m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
                    })
                  ])
                ], -1)),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("h4", _hoisted_29, _toDisplayString(blogs.value.filter((blog) => blog.status.name === "refused").length + travelGuides.value.filter((guide) => guide.status.name === "refused").length), 1),
                  _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-gray-500" }, "Refused", -1))
                ])
              ])
            ])
          ]),
          _cache[12] || (_cache[12] = _createElementVNode("div", null, [
            _createElementVNode("span", null, "Click here to redirect to the"),
            _createElementVNode("a", {
              href: "https://helayes.com",
              target: "_blank",
              class: "mt-4 inline-block px-2 text-blue-600 underline hover:text-blue-700 font-semibold"
            }, [
              _createElementVNode("strong", null, "helayes.com")
            ])
          ], -1))
        ])),
    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "mt-8" }, null, -1))
  ]))
}
}

})